import { defineMessages } from 'react-intl';

export const ACCENT_VALUES = [
  'southern_standard_english',
  'northern_english',
  'midlands',
  'scottish',
  'welsh',
  'irish',
  'london_multicultural_english',
  'non_uk_english',
  'mixed_other',
] as const;

export type AccentValue = (typeof ACCENT_VALUES)[number];

export const accentMessages = defineMessages<AccentValue>({
  southern_standard_english: {
    id: 'nZD9Sr8sug',
    defaultMessage: 'Southern Standard English',
  },
  northern_english: {
    id: 'IO/cX9AJr5',
    defaultMessage: 'Northern English',
  },
  midlands: {
    id: '9gSv5f2GVW',
    defaultMessage: 'Midlands',
  },
  scottish: {
    id: 'QaJTSPqzRt',
    defaultMessage: 'Scottish',
  },
  welsh: {
    id: '3MC1YhhJIT',
    defaultMessage: 'Welsh',
  },
  irish: {
    id: 'GYoPXv5zFU',
    defaultMessage: 'Irish',
  },
  london_multicultural_english: {
    id: 'QhFG4nbl/X',
    defaultMessage: 'London / Multicultural English',
  },
  non_uk_english: {
    id: 'Pl5WjHIH10',
    defaultMessage: 'Non-UK English',
  },
  mixed_other: {
    id: '3uLuMKNqQK',
    defaultMessage: 'Mixed / Other',
  },
});
